<template>
  <div 
    v-if="visible"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    @click="close"
  >
    <div class="bg-white rounded-lg p-6 flex items-center space-x-4 shadow-xl">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      <span class="text-gray-700 font-medium">{{ message }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

interface Props {
  visible?: boolean
  message?: string
  closable?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  visible: true,
  message: 'Loading...',
  closable: false
})

const emit = defineEmits<{
  close: []
}>()

const close = () => {
  if (props.closable) {
    emit('close')
  }
}

// Prevent body scroll when overlay is visible
onMounted(() => {
  if (props.visible) {
    document.body.style.overflow = 'hidden'
  }
})

onUnmounted(() => {
  document.body.style.overflow = ''
})
</script>
